import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { cva } from "class-variance-authority";
import type { LucideIcon } from "lucide-react";

const iconVariants = cva("h-10 w-10 text-muted-foreground");

const iconContainerVariants = cva("mb-4", {
  variants: {
    withContainer: {
      true: "rounded-full bg-muted p-4",
      false: "",
    },
  },
  defaultVariants: {
    withContainer: true,
  },
});

const subtitleVariants = cva(
  "text-sm text-muted-foreground text-center max-w-md",
  {
    variants: {
      hasAction: {
        true: "mb-6",
        false: "",
      },
    },
    defaultVariants: {
      hasAction: false,
    },
  }
);

export interface MunIllustrationAction {
  label: string;
  onClick: () => void;
  icon?: LucideIcon;
}

export interface MunIllustrationProps {
  icon: LucideIcon;
  title: string;
  subtitle: string;
  withContainer?: boolean;
  action?: MunIllustrationAction;
  className?: string;
}

export function MunIllustration({
  icon: Icon,
  title,
  subtitle,
  withContainer = true,
  action,
  className,
}: MunIllustrationProps) {
  const ActionIcon = action?.icon;

  return (
    <Card>
      <CardContent>
        <div
          className={cn(
            "flex flex-col items-center justify-center py-16",
            className
          )}
        >
          <div className={cn(iconContainerVariants({ withContainer }))}>
            <Icon className={cn(iconVariants())} />
          </div>
          <h3 className="text-lg font-semibold mb-2">{title}</h3>
          <p
            className={cn(
              subtitleVariants({
                hasAction: !!action,
              })
            )}
          >
            {subtitle}
          </p>
          {action && (
            <Button onClick={action.onClick}>
              {ActionIcon && <ActionIcon className="h-4 w-4 mr-2" />}
              {action.label}
            </Button>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
